import '../../style/index.less';
import './index.less'; // style dependencies
// deps-lint-skip: select

import '../../select/style';
import '../../empty/style';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/tree-select/style/index.js
// module id = 1343
// module chunks = 0